import React, { Component } from "react";
import { Container, Dropdown, Tab, Tabs } from "react-bootstrap";
import EntryTabs from "./EntryTabs";
import NightAuditChecklist from "./NightAuditChecklist";
import ReviewTasks from "./ReviewTasks";
import { HidSelector } from "../../../../Common/Components/HidSelector";
import "../dailyActivity.scss";
import { Hotel } from "../../../../Common/Services/Hotel";
import moment from "moment";
import { DailyActivityCalendarSelector } from "../DailyActivityCalendarSelector";
import { DailyActivityService } from "../../../../Common/Services/DailyActivity";
import RouteLeavingGuard from "../../../../Common/Components/RouteLeavingGuard";
import { confirmAlert } from "react-confirm-alert";
let routeLeavingGuard: any = null;
export class DailyActivityEntry extends Component<any, any> {
  private childHID: any;

  constructor(props: {}) {
    super(props);
    this.childHID = React.createRef();
    this.state = {
      updatePipOnly: false,
      activeTab: "entry",
      isOverdue: false,
      isLoadingDefaultDate: true,
      calendarDate: null,
      filterHotelId: null,
      selectedHotel:null,
      daysOverdue: 0,
      selectedDate: "",
      
      isTabValuesModified: false,
    };
  }

  getURLhotelId = (): any => {
    const paramObject: any = { hotelId: this.getParamValueByParamName("hotelId") };
    return paramObject;
  };
  getURLhotelNm = (): any => {
    const paramObject: any = { lettercode: this.getParamValueByParamName("lettercode") };
    return paramObject;
  };

  getParamValueByParamName(paramName: string): any {
    const valuesArray = decodeURIComponent(this.props.history.location.search)?.replace("?", "")?.split("&");
    const item = valuesArray?.find((r) => r?.includes(paramName));
    return item?.split("=")[1];
  }

  componentDidMount = (): void => {
    let hotelNm = this.getURLhotelNm()?.lettercode;
    let hotelId = this.getURLhotelId()?.hotelId;
    if (hotelNm && hotelId && this.childHID?.current !== null) {
      this.childHID?.current?.updateChildState({hotelID: atob(hotelId), lettercode: atob(hotelNm) });
      this.setState({ selectedHotel: atob(hotelId) });
    }
    this.setState(
      {
        calendarDate: moment().subtract(1, "days").format("MM/DD/YY"),
      },
      () => {
        this.fetchAuditDate();
      }
    );
  };

  selectHotelDropDown = (hotelDetails: any) => {
    if (!hotelDetails?.hotelID) {
      this.setState({ filterHotelId: hotelDetails?.hotelID,isTabValuesModified:false });
    }
    this.childHID?.current?.updateChildState(hotelDetails);
    this.setState(
      {
        selectedHotel: hotelDetails?.hotelID,
        isLoadingDefaultDate: true,
        isTabValuesModified:false 
      },
      async () => {
        const calendarDate = moment().subtract(1, "days").format("MM/DD/YY");
        await this.fetchAuditDate(calendarDate);
      }
    );
  };

  handleCalendarDate = (date) => {
    if (this.state?.calendarDate !== date) {
      this.setState(
        { calendarDate: date, isLoadingDefaultDate: true },
        this.fetchAuditDate
      );
    }
  };

  setCurrentTabStatusOnValuesChanges = (isTabValuesModified) => {
    this.setState({ isTabValuesModified });
  };

  fetchAuditDate = async (_calendarDate: string = "") => {
    const { selectedHotel, calendarDate } = this.state;
    if (!selectedHotel || (!calendarDate && !_calendarDate)) return;
    try {
      const data = await DailyActivityService.getStartAuditDateNew(
        selectedHotel,
        _calendarDate ? _calendarDate : calendarDate
      );
      const formattedAuditDate = data?.lastAuditDate
        ? moment(data?.lastAuditDate).format("MM/DD/YY")
        : null;





 if (this.state.isTabValuesModified &&this.state.selectedDate != formattedAuditDate) {
      confirmAlert({
        title: "Unsaved Changes",
        message: "You have unsaved changes. Do you want to change date and discard changes?",
        buttons: [
          {
            label: "Yes",
            onClick: () =>  {
              this.setState({
                calendarDate: formattedAuditDate,
                daysOverdue: data?.daysOverdue,
                isLoadingDefaultDate: false,
                selectedDate: formattedAuditDate,
                filterHotelId: selectedHotel,
              });
            },
            
          },
          { label: "No", onClick: () => {

            this.setState({
              calendarDate: this.state.selectedDate,
              isLoadingDefaultDate: false
            });

          } },
        ],
      });
    } else {
      this.setState({
        calendarDate: formattedAuditDate,
        daysOverdue: data?.daysOverdue,
        isLoadingDefaultDate: false,
        selectedDate: formattedAuditDate,
        filterHotelId: selectedHotel,
      });
    }


    
    } catch {
      this.setState({
        isLoadingDefaultDate: false,
        daysOverdue: 0,
        selectedDate: "",
        calendarDate: moment().subtract(1, "days").format("MM/DD/YY"),
      });
    }
  };

  handleTabSelect = (selectedTab: any) => {
    this.setState({ activeTab: selectedTab, isTabValuesModified: false });
  };

  confirmationOnHotelChange = (hotelDetails: any) => {
    if (this.state.isTabValuesModified &&this.state.selectedHotel != hotelDetails?.hotelID) {
      confirmAlert({
        title: "Unsaved Changes",
        message: "You have unsaved changes. Do you want to change hotel and discard changes?",
        buttons: [
          {
            label: "Yes",
            onClick: () =>this.selectHotelDropDown(hotelDetails),
          },
          { label: "No", onClick: () => {} },
        ],
      });
    } else {
      this.selectHotelDropDown(hotelDetails);
    }
  };

 
  confirmationOnTabChange = (selectedTab: any) => {
    if (this.state.isTabValuesModified && this.state.activeTab != selectedTab) {
      confirmAlert({
        title: "Unsaved confirmation?",
        message:
          "You have unsaved changes on this tab. Do you want to leave this tab and discard your changes?",
        buttons: [
          {
            label: "Yes",
            onClick: () =>this.handleTabSelect(selectedTab)
          },
          {
            label: "No",
            onClick: () => {},
          },
        ],
        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    } else {
      this.handleTabSelect(selectedTab);
    }
  };

  routeLeavingGuardConfirm = (childState: any) => {
    if (childState === true) {
      routeLeavingGuard = "routeLeavingGuardTrue";
    } else {
      routeLeavingGuard = null;
    }
  };

  render() {
    const {
      daysOverdue,
      calendarDate,
      isLoadingDefaultDate,
      isTabValuesModified,
      selectedHotel,
    } = this.state;

    return (
      <>
        <RouteLeavingGuard
          when={isTabValuesModified}
          routeLeavingGuardConfirm={this.routeLeavingGuardConfirm}
          shouldBlockNavigation={(location: { pathname: any }) => {
            if (isTabValuesModified) {
              if (location.pathname) {
                return true;
              }
            }
            return false;
          }}
        />
        <div className="daily-activity-module">
          <Container fluid className="body-sec">
            <div className="page-heading d-flex">
              <HidSelector
                onClickEvent={this.confirmationOnHotelChange}
                ref={this.childHID}
                modulename={"DailyActivity"}
                notIncludeEnterpriseAccounts={true}
                showOnlyHotelAccounts={true}
                extraSelector={this.state.updatePipOnly}
                alertComponent={isTabValuesModified}

              />
              <div className="mr-auto">Daily Activity Entry</div>

              {selectedHotel && (
                <>
                  <div className="date-selector d-flex align-items-center">
                    {daysOverdue > 0 && (
                      <div className="badges red">
                        Overdue {daysOverdue}{" "}
                        {daysOverdue == 1 ? "day" : "days"}
                      </div>
                    )}
                    <DailyActivityCalendarSelector
                      id="dailyActivityDateSelector"
                      defaultValue={calendarDate}
                      isDateFetching={isLoadingDefaultDate}
                      onChange={this.handleCalendarDate}
                    />
                  </div>

                  <div className="action-group d-flex">
                    <Dropdown
                      className="pos-static more-action btn-dropdown"
                      alignRight
                    >
                      <Dropdown.Toggle
                        className="btn-outline-primary btn btn-primary more"
                        id="dropdown-more"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                          <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                          <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                        </svg>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item>Demo Link</Dropdown.Item>
                        <Dropdown.Item>Demo Link</Dropdown.Item>
                        <Dropdown.Item>Demo Link</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </>
              )}
            </div>
            {selectedHotel && (
              <Tabs
                activeKey={this.state.activeTab}
                onSelect={this.confirmationOnTabChange}
                mountOnEnter
                unmountOnExit
                id="dailyActivityTabs"
                className="tab-section"
              >
                <Tab
                  eventKey="entry"
                  title={
                    <React.Fragment>
                      <div className="link-area d-flex align-items-center">
                        <div>Entry</div>
                        {/* <div className="count red">{"1"}</div> */}
                      </div>
                    </React.Fragment>
                  }
                >
                  <EntryTabs
                    {...this.state}
                    setCurrentTabStatusOnValuesChanges={
                      this.setCurrentTabStatusOnValuesChanges
                    }
                  />
                </Tab>
                <Tab
                  eventKey="night-audit-checklist"
                  title={
                    <React.Fragment>
                      <div className="link-area d-flex align-items-center">
                        <div>Night Audit Checklist</div>
                        <div className="count red">{"1"}</div>
                      </div>
                    </React.Fragment>
                  }
                >
                  <NightAuditChecklist />
                </Tab>
                <Tab
                  eventKey="review-tasks"
                  title={
                    <React.Fragment>
                      <div className="link-area d-flex align-items-center">
                        <div>Review Tasks</div>
                        <div className="count red">{"1"}</div>
                      </div>
                    </React.Fragment>
                  }
                >
                  <ReviewTasks />
                </Tab>
              </Tabs>
            )}
          </Container>
        </div>
      </>
    );
  }
}
